import { render, staticRenderFns } from "./package_manage.vue?vue&type=template&id=4c36ad14&scoped=true&"
import script from "./package_manage.vue?vue&type=script&lang=js&"
export * from "./package_manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c36ad14",
  null
  
)

export default component.exports